<template>
  <div class="card">
    <div class="card__header">
      <span class="card__title">{{ title }}</span>
      <div>
        <slot name="info" />
        <a-tooltip
          placement="bottomRight"
          arrowPointAtCenter
          :title="isGlobalDownloading ? 'Tiene una descarga pendiente' : 'Descargar dashboard'"
        >
          <a-button
            class="button"
            type="text"
            :disabled="isGlobalDownloading"
            @click="handleDownload"
          >
            <DownloadOutlined />
          </a-button>
        </a-tooltip>
      </div>
    </div>
    <div class="card__body">
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";

export default defineComponent({
  components: {
    DownloadOutlined,
  },
  props: {
    title: { required: true, type: String },
  },
  setup() {
    const { isGlobalDownloading } = useGlobalDownloadState();

    return { isGlobalDownloading };
  },
  methods: {
    handleDownload() {
      Modal.confirm({
        centered: true,
        title: `¿Estás seguro de descargar los detalles del dashboard de ${this.title}?`,
        okText: "Descargar",
        onOk: () => this.$emit("handleDownloadClick"),
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.card
  background-color: $white
  border: $border-normal
  border-radius: 8px

  &__header
    padding: 12px 24px
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: $border-normal

  &__body
    padding: 12px 24px
    position: relative

  &__title
    color: $gray-9
    font-size: 16px
    font-weight: 600

  &__icon
    color: $gray-9
    cursor: pointer

.margin-botton
  margin-bottom: 2px
  color: $gray-8

.right
  margin-right: 10px

.flex
  display: flex
  align-items: center

.text
  color: $gray-8
  font-weight: 600
  margin-right: 5px

.button
  height: 22px
  padding: 0
</style>
